import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../app/store";
import { Service } from "../models/Service";
import { getServicesThunk } from "./thunks/services";

const COMPANY_ADMIN_ROLE = "Company Administrator";
const COMPANY_USER_ROLE = "Company User";

export type AuthUser = {
  isLoggedIn: boolean;
  isAdmin: boolean;
  hasUserPortalAccess: boolean;
  userName: string;
  roles: string[];
  services: Service[];
};

const initialState: AuthUser = {
  isLoggedIn: false,
  isAdmin: false,
  hasUserPortalAccess: false,
  userName: "",
  roles: [""],
  services: [],
};

export const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {
    loginSuccess: (state, action) => {
      state.isLoggedIn = true;
      state.isAdmin = action.payload.roles.some(
        (role: string) => role.toString() === COMPANY_ADMIN_ROLE
      );
      state.hasUserPortalAccess = action.payload.roles.some(
        (role: string) =>
          role.toString() === COMPANY_USER_ROLE ||
          role.toString() === COMPANY_ADMIN_ROLE
      );
      state.userName = action.payload.userName;
      state.roles = action.payload.roles;
    },

    logOut: (state) => {
      state.isAdmin = false;
      state.isLoggedIn = false;
      state.roles = [""];
      state.userName = "";
      state.hasUserPortalAccess = false;
    },
  },

  extraReducers(builder) {
    builder.addCase(getServicesThunk.fulfilled, (state, action) => {
      let services: Service[] = action.payload.services;
      state.services = services.filter((s) => s.hasAccess);
    });
  },
});

export const { loginSuccess, logOut } = authSlice.actions;

export const hasAdminAccess = (state: RootState) => state.auth.isAdmin;
export const isLoggedIn = (state: RootState) => state.auth.isLoggedIn;
export const userName = (state: RootState) => state.auth.userName;
export const services = (state: RootState): Service[] => state.auth.services;
export const hasUserPortalAccess = (state: RootState) =>
  state.auth.hasUserPortalAccess;

export default authSlice.reducer;
